require("./bootstrap");

const getBaseUrl = () => {
    return $('[name="base-url"]').attr("content");
};

const getCrsfToken = () => {
    return $('meta[name="csrf-token"]').attr("content");
};

$(function () {

    $('#cep-input').on('change', async function() {
        let val = $(this).val();
        
        if(val.length < 10) {
            return;
        }

        val = val.replace(/\D/g,'');

        const data = await $.getJSON(`https://brasilapi.com.br/api/cep/v1/${val}`);

        console.log(data);

        if(!data) {
            return;
        }

        $('#address-input').val(data.street);
        $('#neighborhood-input').val(data.neighborhood);
        $('#city-input').val(data.city);
    });

    $(".back-button").on("click", function (e) {
        e.preventDefault();

        const referrer = document.referrer;
        const baseUrl = getBaseUrl();

        if (
            referrer !== "" && //check if referrer exists
            referrer.indexOf(baseUrl) !== -1 && //check if referrer is the store url
            referrer.indexOf("/finalizar-compra") === -1
        ) {
            window.location.href = referrer;
            return;
        }

        window.location.href = baseUrl;
    });

    $(".product-photos").lightSlider({
        gallery: true,
        item: 1,
        loop: true,
        thumbItem: 4,
        //vertical: true,
        slideMargin: 0,
        currentPagerPosition: "left"
    });

    $(".quantity-area .btn-quantity").on("click", function (e) {
        e.preventDefault();

        const thisEl = $(this);
        const quantityEl = $(this)
            .parent()
            .find('input[name="quantity"]');
        const actualQuantity = parseInt(quantityEl.val());

        if (thisEl.hasClass("minus") && actualQuantity > 1) {
            quantityEl.val(actualQuantity - 1).trigger("change");
        }

        if (thisEl.hasClass("plus")) {
            quantityEl.val(actualQuantity + 1).trigger("change");
        }
    });

    function searchProducts(paramName, paramValue, preserveParams = false) {
        console.log(getBaseUrl());
        if (!preserveParams) {
            const url = getBaseUrl() +
                "?" +
                paramName +
                "=" +
                paramValue;

            window.location.href = url;
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(paramName, paramValue);

        const url = getBaseUrl() + "?" + urlParams.toString();
        window.location.href = url;
    }

    $("form.selectors").on("submit", function (e) {
        e.preventDefault();

        let search = $(this)
            .find('input[name="s"]')
            .val();
        if (search == "" || !search) return;
        searchProducts("s", search, false);
    });

    $(".selectors .order-selector").on("change", function (e) {
        e.preventDefault();
        searchProducts("o", $(this).val(), true);
    });

    $(".categories-area-mobile button.item").on("click", function (e) {
        e.preventDefault();
        let categorySlug = $(this).attr("data-slug");
        searchProducts("c", categorySlug, false);
    });

    if (
        $(".selectors .categories-area-mobile .wrapper .item.active").length > 0
    ) {
        $(
            ".selectors .categories-area-mobile .wrapper .item.active"
        )[0].scrollIntoViewIfNeeded();
    }

    $(".product-page .buy-button").on("click", function (e) {
        e.preventDefault();

        let quantity = parseInt($('.product-page input[name="quantity"]').val());
        let quantityAvailable = parseInt($('.in-stock-number').text());

        if (productManageStock && quantity > quantityAvailable) {

            $.alert({
                title: 'Estoque indisponível',
                content: 'A quantidade selecionada é maior que o estoque disponível',
                type: 'red',
                useBootstrap: false
            });
            return;
        }

        let attributes = [];
        let variationEls = $(".product-page .attribute-selector");
        if (variationEls.length > 0) {
            variationEls.each(function () {
                const name = $(this).attr('name');
                const value = $(this).val();

                attributes.push({name, value});
            });
        }
        const product_id = $(".product-page #product_id").val();
        const variation_id = $(".product-page #variation_id").val();

        const postData = {
            product_id,
            variation_id,
            quantity,
            attributes
        };

        $.ajax({
            method: "POST",
            datatype: "JSON",
            data: postData,
            url: `${getBaseUrl()}/api/cart`,
            beforeSend: () => {
                $(".product-page .buy-button")
                    .addClass("disabled")
                    .text("Adicionando...");
            },
            success: res => {
                $(".product-page .buy-button")
                    .removeClass("disabled")
                    .text("Produto adicionado!");
                setTimeout(() => {
                    window.location.href = `${getBaseUrl()}/carrinho`;
                }, 250);
            },
            error: () => {
                $(".product-page .buy-button")
                    .removeClass("disabled")
                    .text("Adicionar ao Carrinho");
                $(".product-page .error-alert").remove();
                $(
                    '<div class="error-alert">Ocorreu um erro ao adicionar o produto ao carrinho, por favor tente mais tarde.</div>'
                ).insertAfter(".product-page .buy-button");
            }
        });
    });

    $('.cart-page input[name="quantity"]').on("change", function (e) {
        e.preventDefault();

        const cart_item_id = $(this).data('itemId');
        const quantity = $(this).val();
        const quantityAvailable = parseInt($(this).parent().parent().find('.in-stock-number').text());

        if (quantity > quantityAvailable) {
            $.alert({
                title: 'Estoque indisponível',
                content: 'A quantidade selecionada é maior que o estoque disponível',
                type: 'red',
                useBootstrap: false
            });
            $(this).val(quantityAvailable);
            return;
        }

        const postData = {
            cart_item_id: cart_item_id,
            quantity
        };

        $.ajax({
            url: `${getBaseUrl()}/api/cart/update`,
            method: "PUT",
            datatype: "JSON",
            data: postData,
            success: () => {
                window.location.reload();
            }
        });
    });

    $(".cart-page .remove-product").on("click", function (e) {
        e.preventDefault();

        const cart_item_id = $(this).data('item-id');

        const postData = {
            cart_item_id
        };

        $.ajax({
            url: `${getBaseUrl()}/api/cart/delete`,
            method: "DELETE",
            datatype: "JSON",
            data: postData,
            success: () => {
                window.location.reload();
            }
        });
    });

    if (
        $('#delivery_method option:selected').attr(
            "data-is-delivery"
        ) !== undefined
    ) {
        $(".checkout-page .delivery-address-area").show();
        $(".checkout-page .delivery-price").show();
        $(".delivery-address-area input[data-required]").attr("required", "required");
    } else {
        $(".checkout-page .delivery-address-area").hide();
        $(".checkout-page .delivery-price").hide();
        $(".delivery-address-area input").removeAttr("required");
    }

    $('#delivery_method').on("change", function (e) {
        if ($(
            '#delivery_method option:selected'
        ).attr("data-is-delivery") !== undefined) {
            $(".checkout-page .delivery-address-area").show();
            $(
                '.checkout-page .delivery-address-area input[name="address"]'
            ).focus();
            $(".checkout-page .delivery-price").show();
            $(".delivery-address-area input[data-required]").attr("required", "required");
        } else {
            $(".checkout-page .delivery-address-area").hide();
            $(".checkout-page .delivery-price").hide();
            $(".delivery-address-area input").removeAttr("required");
        }
    });

    if (
        $('.checkout-page select[name="Pagamento"] option:selected').attr(
            "data-is-cash"
        ) !== undefined
    ) {
        $('.checkout-page input[name="change"]')
            .show()
            .focus();
    } else {
        $('.checkout-page input[name="change"]').hide();
    }

    $('.checkout-page select[name="Pagamento"]').on("change", function (e) {
        if (
            $(
                '.checkout-page select[name="Pagamento"] option:selected'
            ).attr("data-is-cash") !== undefined
        ) {
            $('.checkout-page input[name="Troco"]')
                .show()
                .focus()
                .attr("required", "required");
        } else {
            $('.checkout-page input[name="Troco"]')
                .hide()
                .removeAttr("required");
        }
    });

    var SPMaskBehavior = function (val) {
            return val.replace(/\D/g, "").length === 11
                ? "(00) 00000-0000"
                : "(00) 0000-00009";
        },
        spOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
            }
        };

    $(".phone-mask").mask(SPMaskBehavior, spOptions);

    $(".money-mask").maskMoney({
        allowNegative: true,
        thousands: ".",
        decimal: ",",
    });

    $(".checkout-page .checkout-form").on("submit", function (e) {
        e.preventDefault();

        let isCash =
            $(
                '.checkout-page select[name="payment_type"] option:selected'
            ).attr("data-is-cash") !== undefined;

        if (isCash) {
            let orderTotal = parseFloat($("#order_total_float").val());
            let deliverTax = parseFloat($("#delivery_tax_float").val());

            if ($('select[name="delivery_type"]').val() == "Entregar em Casa") {
                orderTotal += deliverTax;
            }

            let change =
                parseFloat(
                    $('input[name="order_change"]')
                        .val()
                        .replace(/[^0-9]/, "")
                ) / 100;

            if (change < orderTotal) {
                alert(
                    "O valor para troco deve ser maior que o total do pedido que é R$ " +
                    orderTotal.toString().replace(".", ",")
                );
                return;
            }
        }

        let formData = $(this).serialize();

        $.ajax({
            url: `${getBaseUrl()}/api/checkout`,
            method: "POST",
            dataType: "JSON",
            data: formData,
            beforeSend: function () {
                $(".checkout-page .buy-button").text("Gerando Pedido...");
            },
            success: function () {
                $(".checkout-page .buy-button").text("Pedido Gerado!");
                window.location.href = `${getBaseUrl()}/obrigado`;
            },
            error: function () {
                $(
                    '<span class="error-alert">Ocorreu um erro ao gerar seu pedido, por favor tente novamente mais tarde.</span>'
                ).insertAfter(".checkout-page .buy-button");
                $(".checkout-page .buy-button").text("Enviar Meu Pedido");
            }
        });
    });

    if ($(".thankyou-page .submit-wrapper .whatsapp-send-button").length > 0) {
        let whatsLinkHref = $(
            ".thankyou-page .submit-wrapper .whatsapp-send-button"
        ).attr("href");
        if (whatsLinkHref != "") {
            setTimeout(() => {
                window.location.href = whatsLinkHref;
            }, 1500);
        }
    }

    $(window).on("beforeunload", function () {
        $.LoadingOverlay("show", {
            imageColor: "var(--color2)"
        });
    });

    function changeStock(hasStock = false) {
        if (!hasStock) {
            $('.product-page .buy-button').attr('disabled', 'disabled');
            $('.not-found-text').show();
        } else {
            $('.product-page .buy-button').removeAttr('disabled');
            $('.not-found-text').hide();
        }
    }

    function verifyForVariations() {
        if (typeof productVariations === 'undefined') {
            if (typeof productManageStock !== 'undefined' && !productManageStock) {
                changeStock(true);
                return;
            }

            if (typeof productHasStock !== 'undefined' && productHasStock) {
                changeStock(true);
                return;
            }

            changeStock(false);

            return;
        }
        ;

        const attributes = {};
        $('.product-page .variation select').each((index, el) => {
            const $el = $(el);
            let name = $el.attr('name').replace('attribute[', '').replace(']', '');
            attributes[name] = $el.val();
        });

        const selectedVariationIndex = productVariations.findIndex(variation => {
            function orderObject(objVar) { 
                
                return Object.keys(objVar).sort().reduce(
                  (obj, key) => { 
                    obj[key] = objVar[key]; 
                    return obj;
                  }, 
                  {}
                );
            };
            
            let vAttrs = JSON.stringify(orderObject(variation.attributes));
            let aAttrs = JSON.stringify(orderObject(attributes));
            return vAttrs == aAttrs;
        });
        
        if (selectedVariationIndex === -1) {
            console.log('Erro ao buscar variação');
            return;
        }
        const selectedVariation = productVariations[selectedVariationIndex];

        $('#variation_id').val(selectedVariation.id);
        $('.in-stock-text .in-stock-number').text(selectedVariation.stock);

        if (Number(selectedVariation.stock) < 1 && productManageStock === true) {
            $('.product-page .buy-button').attr('disabled', 'disabled');
            $('.not-found-text').show();
        } else {
            $('.product-page .buy-button').removeAttr('disabled');
            $('.not-found-text').hide();
        }

        const brlNumber = Intl.NumberFormat('pt-br', {
            currency: 'BRL',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        }).format(selectedVariation.price);
        $('.current-price').html(`<small>Por: </small>R$ ${brlNumber}`);
    }

    function selectDefaultPriceValue() {
        if (
            typeof productVariations === "undefined" ||
            typeof productDefaultValue === "undefined"
        ) {
            return;
        }

        const index = productVariations.findIndex(variation => variation.price === productDefaultValue);
        if (index === -1) {
            return;
        }

        const productVariation = productVariations[index];

        Object.keys(productVariation.attributes).forEach(attribute => {
            $(`[name="attribute[${attribute}]"]`).val(productVariation.attributes[attribute]).change();
        });
    }

    selectDefaultPriceValue();
    $('.product-page .variation select').on('change', verifyForVariations);
    verifyForVariations();

    $('[data-show-if-enabled]').each(function () {
        let targetElName = $(this).attr('data-show-if-name');
        let targetElValue = $(this).attr('data-show-if-value');

        let targetEl = $(`[name="${targetElName}"]`);
        let formGroupEl = $(this);

        if (targetEl.val() == targetElValue) {
            formGroupEl.show();
            formGroupEl.find('[data-required]').attr('required', 'required');
        } else {
            formGroupEl.hide();
            formGroupEl.find('[required]').removeAttr('required').attr('data-required', 'required');
        }

        targetEl.on('change', (event) => {
            if ($(event.target).val() == targetElValue) {
                formGroupEl.show();
                formGroupEl.find('[data-required]').attr('required', 'required');
            } else {
                formGroupEl.hide();
                formGroupEl.find('[required]').removeAttr('required').attr('data-required', 'required');
            }
        })
    })
});
